
<template>
  <div class="pageContent">
    <div
      style=" background: url(../../../static/user/center/主页顶部.jpg) ; width:100%  ;  
            color: white ; font-size:0.34rem ; overflow:hidden  ;   background-size:cover "
    >
      <div style="padding-top:0.2rem ;  ">
        <table style="width:100%">
          <tr>
            <td style="width:33%"></td>
            <td style="width:33% ; font-size:0.4rem">我</td>
            <td
              style="width:33% ; font-size:0.32rem ; padding-top:0.1rem ; padding-right: 0.3rem"
              v-on:click="qiandao"
              align="right"
            >
              <div v-if="this.g_UserInfo.isSignInedToday">已签到</div>
              <div v-if="!this.g_UserInfo.isSignInedToday">签到</div>
            </td>
          </tr>
        </table>
      </div>
      <img
        src="../../../static/user/center/主页头像.png"
        style="width:1.6rem; padding : 0.7rem 0 0.4rem 0.3rem ; float:left"
        v-on:click="goBaseInfo"
      >

      <div style="float:left ; padding : 0.9rem 0 0 0.4rem" align="left" v-on:click="goBaseInfo">
        <div>{{ UserName }}</div>
        <div style="font-size:0.24rem ; color:#94e588 ; margin-top:0.1rem">基本信息 ></div>
      </div>

      <div style="float:right">
        <mu-chip
          v-on:click="goVipCard()"
          style="  background-color: #FFBF3B ;  color: white;  margin-top: 1rem  ; width:2.1rem  ; margin-right:-0.3rem ; font-size:0.26rem  ;"
        >
          <div style=" margin:0 auto 0 auto">
            <img
              src="../../../static/user/vipcard/CardLeft.png"
              style=" margin-left:0.05rem;   width:0.26rem ; margin-bottom : -0.05rem "
            >
            {{ CardType }}
            <img
              src="../../../static/user/vipcard/CardRight.png"
              style="  width:0.26rem ; margin-bottom: -0.05rem ; margin-right:0.2rem "
            >
          </div>
        </mu-chip>
      </div>
    </div>

    <table style="margin-top:2vh ; font-size:0.18rem">
      <tr>
        <td style="width:50%">
          <!--线条-->
          <hr style="border:none; border-top:1px solid #e2e2e2;">
        </td>
        <td style="font-size:0.26rem">
          <nobr>我的特权</nobr>
        </td>
        <td style="width:50%">
          <!--线条-->
          <hr style="border:none; border-top:1px solid #F1F1F1;">
        </td>
      </tr>
    </table>

    <!--————我的特权————-->
    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '数字卡' ">
      <div class="tequan">
        <img src="../../../static/user/center/打折.png" style="   ">
        <br>9.5折
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/积分.png" style="  ">
        <br>积1倍K币
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>13:00退房
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/代金券.png" style="  ">
        <br>电子代金券
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/99特惠.png" style="  ">
        <br>998特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/生日.png" style="  ">
        <br>生日礼物
      </div>
      <!--<div class="tequan">
            <img src="../../../static/user/center/同行.png" style="  " />
            <br /> 同行特惠
      </div>-->
      <!--<div class="tequan">
        <img src="../../../static/user/center/免押金.png" style="  " />
        <br /> 免押金
      </div>-->
    </div>

    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '贵宾卡' ">
      <div class="tequan">
        <img src="../../../static/user/center/打折.png" style="   ">
        <br>9.2折
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/积分.png" style="  ">
        <br>积2倍K币
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>13:00退房
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/代金券.png" style="  ">
        <br>电子代金券
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/99特惠.png" style="  ">
        <br>998特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/生日.png" style="  ">
        <br>生日礼物
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/同行.png" style="  ">
        <br>同行特惠
      </div>
      <!--<div class="tequan">
        <img src="../../../static/user/center/免押金.png" style="  " />
        <br /> 免押金
      </div>-->
    </div>

    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '贝壳卡' ">
      <!--<div class="tequan">
            <img src="../../../static/user/center/打折.png" style="   " />
            <br /> 9.5折
      </div>-->
      <div class="tequan">
        <img src="../../../static/user/center/积分.png" style="  ">
        <br>积12倍K币
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>14:00退房
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/代金券.png" style="  ">
        <br>电子代金券
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/69特惠.png" style="  ">
        <br>69特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/生日.png" style="  ">
        <br>生日礼物
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/同行.png" style="  ">
        <br>同行特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/免押金.png" style="  ">
        <br>免押金
      </div>
    </div>

    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '金卡' ">
      <div class="tequan">
        <img src="../../../static/user/center/打折.png" style="   ">
        <br>8.8折
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/积分.png" style="  ">
        <br>积2.5倍K币
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>14:00退房
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/代金券.png" style="  ">
        <br>电子代金券
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/99特惠.png" style="  ">
        <br>998特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/生日.png" style="  ">
        <br>生日礼物
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/同行.png" style="  ">
        <br>同行特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/免押金.png" style="  ">
        <br>免押金
      </div>
    </div>

    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '铂金卡' ">
      <div class="tequan">
        <img src="../../../static/user/center/打折.png" style="   ">
        <br>8.5折
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/积分.png" style="  ">
        <br>积3倍K币
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>14:00退房
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/代金券.png" style="  ">
        <br>电子代金券
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/99特惠.png" style="  ">
        <br>998特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/生日.png" style="  ">
        <br>生日礼物
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/同行.png" style="  ">
        <br>同行特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/免押金.png" style="  ">
        <br>免押金
      </div>
    </div>

    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '员工卡' ">
      <div class="tequan">
        <img src="../../../static/user/center/打折.png" style="   ">
        <br>7折
      </div>
      <!--<div class="tequan">
            <img src="../../../static/user/center/积分.png" style="  " />
            <br /> 积1倍K币
      </div>-->
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>13:00退房
      </div>
      <!--<div class="tequan">
            <img src="../../../static/user/center/代金券.png" style="  " />
            <br /> 电子代金券
      </div>-->
      <!--<div class="tequan">
        <img src="../../../static/user/center/99特惠.png" style="  " />
        <br /> 998特惠
      </div>-->
      <!--<div class="tequan">
            <img src="../../../static/user/center/生日.png" style="  " />
            <br /> 生日礼物
      </div>-->
      <div class="tequan">
        <img src="../../../static/user/center/同行.png" style="  ">
        <br>同行特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/免押金.png" style="  ">
        <br>免押金
      </div>
    </div>

    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '翡翠卡' ">
      <div class="tequan">
        <img src="../../../static/user/center/打折.png" style="   ">
        <br>7折
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/积分.png" style="  ">
        <br>积3倍K币
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>14:00退房
      </div>
      <!--<div class="tequan">
            <img src="../../../static/user/center/代金券.png" style="  " />
            <br /> 电子代金券
      </div>-->
      <!--<div class="tequan">
        <img src="../../../static/user/center/99特惠.png" style="  " />
        <br /> 998特惠
      </div>-->
      <!--<div class="tequan">
            <img src="../../../static/user/center/生日.png" style="  " />
            <br /> 生日礼物
      </div>-->
      <div class="tequan">
        <img src="../../../static/user/center/同行.png" style="  ">
        <br>同行特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/免押金.png" style="  ">
        <br>免押金
      </div>
    </div>

    <div class="ALLtequan" v-if="g_UserInfo.Card_Kind_Diplay == '联名卡' ">
      <div class="tequan">
        <img src="../../../static/user/center/打折.png" style="   ">
        <br>折扣
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/积分.png" style="  ">
        <br>积分
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/退房.png" style="   ">
        <br>延时退房
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/代金券.png" style="  ">
        <br>电子代金券
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/99特惠.png" style="  ">
        <br>998特惠
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/生日.png" style="  ">
        <br>生日礼物
      </div>
      <div class="tequan">
        <img src="../../../static/user/center/同行.png" style="  ">
        <br>同行特惠
      </div>
      <!--<div class="tequan">
            <img src="../../../static/user/center/免押金.png" style="  " />
            <br /> 免押金
      </div>-->
    </div>

    <!--分割线-->
    <div class="greyline" style=" background-color: #F5F5F5 ;height:1.5vh"></div>
    <div class="mList">
      <div class="mItem" v-on:click="goMyCollection()">
        <img src="../../../static/user/Entrance/collect.png">
        <span>我的收藏</span>
      </div>
      <mu-divider/>

      <div class="mItem" v-on:click="goMyComments">
        <img src="../../../static/user/Entrance/comment.png">
        <span>我的点评</span>
      </div>
      <mu-divider/>

      <div class="mItem" v-on:click="goInvoiceManage()">
        <img src="../../../static/user/Entrance/invoice.png">
        <span>发票管理</span>
      </div>
      <mu-divider/>
      <div class="mItem" v-on:click=" goBreakfast()   ">
        <img src="../../../static/user/Entrance/breakfast.png">
        <span>我的早餐券</span>
      </div>
      <mu-divider/>
      <div class="mItem" v-on:click="goCheckInMan">
        <img src="../../../static/user/Entrance/resident.png">
        <span>常住人员管理</span>
      </div>
      <mu-divider/>
      <div class="mItem" v-on:click="goFreeVo()">
        <img src="../../../static/user/Entrance/freeVo.png">
        <span>我的免房券</span>
      </div>
    </div>

    <div class="greyline" style=" background-color: #F5F5F5 ;height:1.5vh"></div>

    <mu-list-item style="font-size:0.32rem ; " v-on:click="goLogout">
      <div style="color:#FF5A5A">退出当前用户</div>
    </mu-list-item>

    <div style="min-height: 1.5rem   ;background-color: #F5F5F5 "></div>

    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="this.TellUser" @close="hideToast" id="alertline"/>
    <pop
      :display="popDisplayU"
      @closeHandler="closePop"
      @okHandler="closeYESU"
      title="提示"
      :msg="popMsg"
      :onlyOk="popOnlyOk"
    />
  </div>
</template>







<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../api";

export default {
  data() {
    return {
      // 弹出层
      toast: false,

      TellUser: "",

      UserName: "",
      CardType: "",
      popDisplayU: false,
      popOnlyOk: false,
      popMsg: "未激活无法进行预定，是否先激活",
      cardname: "",
      cardphone: "",
      cardkind: "",
      cardno: ""
    };
  },
  activated() {
    this.UserName = this.g_UserInfo.Name;
    this.CardType = this.g_UserInfo.Card_Kind_Diplay;
    // console.log(this.g_UserInfo.IsActivated);
    // if(!this.g_UserInfo.IsActivated&&!this.g_UserInfo.IsOtherUser){
    //   this.popDisplayU = true;
    //   this.popMsg = "会员卡未激活，不支持预定，前往激活";
    // }
    //console.log(this.g_UserInfo.Card_Kind_Diplay);

    this.checklogin();
  },
  computed: {
    ...mapGetters(["g_UserInfo"])
  },
  methods: {
    ...mapMutations(["setG_UserInfo"]),
    //取消激活
    closePop() {
      this.popDisplayU = false;
    },
    closeYESU() {
      this.popDisplayU = false;
      console.log(this.cardphone);
      this.$router.push({
        path:
          "/user/activation?cardkind=" +
          this.g_UserInfo.Card_Kind_Diplay +
          "&cardno=" +
          this.g_UserInfo.Card_no +
          "&cardphone=" +
          this.g_UserInfo.Phone +
          "&cardname=" +
          this.g_UserInfo.Name
      });
      //  this.$router.push({ path: "/user/activation",params:{cardkind:this.cardkind,cardno:this.cardno,cardphone:this.cardphone,cardname:this.cardname}});
    },
    checklogin() {
      if (this.g_UserInfo.Card_no != "") {
        this.g_UserInfo.IsOtherUser = null;
        this.g_UserInfo.OtherUserID = null;
      }

      if (this.g_UserInfo.IsOtherUser) {
        this.$router.push({ path: "/user/Login" });
        return;
      }

      //获取登录状态
      var params = new this.URLSearchParam();
      params.append("cardNo", this.g_UserInfo ? this.g_UserInfo.Card_no : "");
      this.$http.post(api.loginState(), params.toParam()).then(res => {
        if (res.Result) {
        } else {
          this.goLogout();
        }
      });
    },

    // 跳转 登出
    goLogout() {
      // 接口登出
      this.$http.post(api.LogOff()).then(res => {
        if (res.Result) {
          this.$store.commit("CLEARUSER");

          this.$router.push({ path: "/user/Login" });
        } else {
          this.TellUser = res.Message;
          this.showToast();
        }
      });
    },

    goBaseInfo() {
      this.$router.push({ path: "/user/baseInfo" });
    },
    // 跳转 会员卡详情
    goVipCard() {
      // this.$router.push({ path: '/user/VipIndex/index/' + this.g_UserInfo.Card_Kind_Diplay });
      //this.$router.push({ path: "/user/VipIndex/index" });
      var url = this.g_UserInfo != null && 
      this.g_UserInfo != undefined &&
      this.g_UserInfo.Card_Kind_Diplay != null && 
      this.g_UserInfo.Card_Kind_Diplay !='' ? 'https://h5app.greentree.cn/memberShip/index.html?cardKind=' + this.g_UserInfo.Card_Kind_Diplay : 'https://h5app.greentree.cn/memberShip/index.html';
      window.location.href = url;
    },

    // 跳转 我的收藏
    goMyCollection() {
      this.$router.push({ path: "/user/myCollection" });
    },

    // 跳转 发票管理
    goInvoiceManage() {
      this.$router.push({ path: "/user/invoiceManage" });
    },

    //跳转 会议室订单
    goBoardRoomOrderList() {
      this.$router.push({ path: "/bookBoardRoom/orderList" });
    },

    //跳转 我的点评
    goMyComments() {
      this.$router.push({ path: "/comments/myComments" });
    },

    // gong neng 功能
    // 弹出层  签到
    qiandao() {
      if (this.CardType == "员工卡") {
        this.TellUser = "员工卡不支持签到";
        //显示阴影层
        this.showToast();
        return;
      }
      this.$http.post(api.Signature()).then(res => {
        if (res.Result) {
          this.TellUser = res.Data;
        } else {
          this.TellUser = res.Message;
        }
        this.g_UserInfo.isSignInedToday = true;

        //显示阴影层
        this.showToast();
      });
    },

    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 1500);
      if (this.TellUser == "未登录") {
        this.$store.dispatch("clearUser");
        this.toastTimer = setTimeout(() => {
          this.$router.push({ path: "/user/login" });
        }, 1800);
      }
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    goFreeVo() {
      //跳转免房券
      this.$router.push({ path: "/wallet/freeVouchers" });
    },
    goBreakfast() {
      //  早餐
      this.$router.push({ path: "/user/Breakfast" });
    },
    goCheckInMan() {
      //常住人员管理
      this.$router.push({ path: "/user/PassengerMsg" });
    }
  }
};
</script>


<style lang="less" scoped="">
@import "../../assets/theme.less";

.mItem {
  color: #333333;
  font-size: 0.32rem;
  display: flex;
  padding-left: 1em;
  img {
    width: 28px;
    margin: auto 5px auto 0;
  }
  span {
    margin: auto 0;
  }
}

.ALLtequan {
  margin: 0.3rem auto 0rem auto;
  overflow: hidden;
  width: 94%;
  color: #666666;
  font-size: 0.24rem;
}

.green {
  background-color: @primaryColor;
}

#greenfont {
  color: @primaryColor;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  position: absolute;
  .tequan {
    width: 1.75rem;
    margin-bottom: 0.3rem;

    float: left;

    img {
      width: 0.48rem;
    }
  }
}
</style>








// WEBPACK FOOTER //
// UserCenter.vue?68faeb76